// extracted by mini-css-extract-plugin
export default {"image":"bJ_dx","isHidden":"bJ_hK"};